<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialogRemove"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogRemove"
      >
      <v-card class="no__padding">
        <v-card-title>
          <h2>Smazání objednávky</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          Opravu chcete smazat <strong>{{ removeItem.sporici_program }}</strong> z objednávek?
        </v-card-text>
        <v-divider class="mt-2 mb-2"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red elevation-0" dark @click="remove" :loading="removing"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>
          <v-btn color="grey elevation-0 lighten-3" @click="dialogRemove=false" v-if="!removing">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div v-if="!editMode">
            <v-card color="grey lighten-4" class="pa-3 no__radius">
              <v-breadcrumbs divider="/" large disabled="false" class="pa-0">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item>
                  <v-btn color="blue" outline @click="gotoall" class="ma-0">Objednávky spořících produktů</v-btn>
                </v-breadcrumbs-item>
                <v-breadcrumbs-item>
                  Název
                </v-breadcrumbs-item>
              </v-breadcrumbs>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <p class="body-3 mb-0 bold">Detail objednávky spořícího produktu</p>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Jméno klienta / Název firmy:</p>
                    <strong v-if="promenna != null">{{promenna}}</strong><span v-else>--</span>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Datum sjednání:</p>
                    <strong v-if="promenna != null">{{promenna}}</strong><span v-else>--</span>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Název spoření:</p>
                    <strong v-if="promenna != null">{{promenna}}</strong><span v-else>--</span>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Spořící program:</p>
                    <strong v-if="promenna != null">{{promenna}}</strong><span v-else>--</span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">VS:</p>
                    <strong v-if="promenna != null">{{promenna}}</strong><span v-else>--</span>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Cílová částka:</p>
                    <strong v-if="promenna != null">{{promenna}}</strong><span v-else>--</span>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Měsíční platba:</p>
                    <strong v-if="promenna != null">{{promenna}}</strong><span v-else>--</span>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">První platba:</p>
                    <strong v-if="promenna != null">{{promenna}}</strong><span v-else>--</span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Cílový produkt:</p>
                    <strong v-if="promenna != null">{{promenna}}</strong><span v-else>--</span>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card color="grey lighten-4" class="pt-3 pr-3 pl-3 pb-1 mt-4 no__radius">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <p class="body-3 mb-0 bold">Uskutečněné platby</p>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <div class="elevation-1">
                      <v-data-table
                        :headers="headers"
                        :items="items"
                        hide-controls
                      >
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.datum }}</td>
                          <td>{{ props.item.castka }}</td>
                          <td>{{ props.item.cislo_uctu }}</td>
                          <td>{{ props.item.cislo_protiuctu }}</td>
                          <td>{{ props.item.vs }}</td>
                        </template>
                      </v-data-table>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="mt-3">
                    <p>Celkem X = 30 % z celkové sjednané částky</p>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card-actions class="mt-4">
              <v-btn color="primary" @click="editMode=true" class="elevation-0"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click="remove" :loading="removing"><v-icon small class="mr-2">delete</v-icon>Smazat</v-btn>
            </v-card-actions>
          </div>

          <div v-else>
            <v-card color="grey lighten-4" class="pa-3 no__radius">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <p class="body-2 mb-0 bold">Detail objednávky spořícího produktu</p>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <clientsearch label="Jméno Klienta / Název firmy" class="mx-2"></clientsearch>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Datum sjednání" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Název spoření" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <sporiciproduktsearch label="Spořící program" class="mx-2"></sporiciproduktsearch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="VS" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Cílová částka" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Měsíční platba" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="První platba" class="mx-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <productsearch label="Cílový produkt" class="mx-2"></productsearch>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card-actions class="mt-4">
              <v-btn color="primary" @click="edit" :loading="updating" class="elevation-0"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
              <v-btn color="red" flat @click="editMode=false"><v-icon small class="mr-2">rotate_left</v-icon>Vrátit změny</v-btn>
            </v-card-actions>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      editMode: false,
      promenna: null,
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Částka', value: 'castka' },
        { text: 'Č. účtu', value: 'cislo_uctu' },
        { text: 'Č. protiúčtu', value: 'cislo_protiuctu' },
        { text: 'VS', value: 'vs' }
      ],
      items: [
        {
          datum: '2. 1. 2019',
          castka: '2 000 Kč',
          cislo_uctu: '1234',
          cislo_protiuctu: '1234',
          vs: '7776665552'
        }
      ],
      item: {},
      dialogUpdate: false,
      updateItem: {},
      dialogRemove: false,
      removeItem: {},
      updating: false,
      removing: false,
      // Item variables end
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ]
    }
  },
  props: {
    id: String
  },
  mounted: function() {
    //this.load();
  },
  methods: {
    load () {
      window.api.get("sporici-produkty/" + this.$props.id).then((_body) => {
        this.item = _body;
        this.loading = false;
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    },
    editClick () {
      this.updateItem = window.th.copy(this.item);
      this.editMode = true;
    },
    edit () {
      this.updating = true;
      window.api.put("sporici-produkty/" + this.$props.id, this.updateItem).then((_body) => {
        if (_body.updated) {
          this.item = window.th.copy(this.updateItem);
          this.editMode = false;
        }
        this.updating = false;
      }).catch((err) => {
        console.log(err);
        this.updating = false;
      });
    },
    removeClick () {
      this.removeItem = window.th.copy(this.item);
      this.dialogRemove = true;
    },
    remove () {
      this.removing = true;
      window.api.delete("sporici-produkty/" + this.$props.id).then((_body) => {
        if (_body.deleted) {
          this.$router.push({ path: "/sporici-produkty" })
        }
        this.removing = false;
      }).catch((err) => {
        console.log(err);
        this.removing = false;
      });
    },
    gotoall () {
      this.$router.push({ path: "/objednavky-sporici" });
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Objednavky/ObjednavkyDetail.vue